import React from 'react';
import Styled from 'styled-components/macro';
import {CSS_CONSTANTS} from '../../../../../css_variables';

const BreadcrumbsSectionWrapper = Styled.div`
	font-size: 11px;
	height:32px;
	display:flex;
	flex-direction:row;
	align-items:center;
	border-bottom:solid 1px ${() => CSS_CONSTANTS.app_border_color};
	padding: 0 8px 0 24px;
`;

const NamesSection = Styled.div`
	display:flex;
	flex-direction:row;
	flex:1;
`;

const SlashWrapper = Styled.div`
	margin:0 8px;
	color:#A5A5AE;
`;

const NameWrapper = Styled.div`
	color:#4C4C58;
	max-width:270px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

const ParentNameWrapper = Styled(NameWrapper)`
	color:#A5A5AE;
	cursor:pointer;
	&:hover{
		color:#6E0FEB;
	}
`;

// The trail of parents above a task opened from inside a hierarchy. Closing the modal is not this
// component's job: the header below carries one close control, beside the task's own actions, and a
// second one on its own line above it reads as belonging to the breadcrumb rather than the modal.
//
// A task with no parents has no trail. That case is decided by the caller, which renders this
// component only when there are parents and puts the modal's own top spacing there instead - so
// there is no empty-list branch here to keep in step with it.
const BreadcrumbsSection = ({parentsList, taskName, history, openTask}) => {
	const parentsBreacrumbs = parentsList.map(parent => {
		return (
			<>
				<ParentNameWrapper onClick={() => openTask(parent.companyTaskId)}>{parent.name}</ParentNameWrapper>
				<SlashWrapper>/</SlashWrapper>
			</>
		);
	});

	return (
		<BreadcrumbsSectionWrapper>
			<NamesSection>
				{parentsBreacrumbs}
				<NameWrapper>{taskName}</NameWrapper>
			</NamesSection>
		</BreadcrumbsSectionWrapper>
	);
};

export default BreadcrumbsSection;
